import { Box, TablePagination } from "@mui/material";
import React from "react";
import Colors from "../../theme/Colors";
import Fonts from "../../Config/Fonts";

const PaginationComponent = ({
  page,
  rowsPerPage = 25, // Default rows per page value set to 25
  handlePageChange,
  handleChangeRowsPerPage,
  totalItems,
  rowsPerPageOptions, // Default options including 25
  rowsPerPageLabel, // Default label for rows per page
}) => {
  return (
    <Box>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={totalItems || 0} // Fixed count fallback to 0 instead of an empty array
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage={rowsPerPageLabel} // Use custom label text
        sx={{
          "& .MuiTablePagination-toolbar": {
            fontSize: 14,
            fontWeight: 700,
            fontFamily: Fonts.Poppins,
            color: Colors.black,
          },
          "& .MuiTablePagination-actions button": {
            fontSize: 24,
            fontWeight: 900,
            fontFamily: Fonts.Poppins,
            color: Colors.primaryColor,
          },
          "& .MuiTablePagination-actions .Mui-selected": {
            color: Colors.primaryColor, // Active color
            fontWeight: "bold", // Bold font for selected page
          },
          "& .MuiTablePagination-actions .Mui-disabled": {
            color: "rgba(0, 0, 0, 0.38)", // Disabled color (if needed)
          },
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              fontSize: 13,
              fontWeight: 600,
              fontFamily: Fonts.Poppins,
              color: Colors.black,
            },
          "& .MuiTablePagination-select": {
            border: `2px solid ${Colors.darkGray}`, // Add border around rows per page select dropdown
            borderRadius: "5px", // Add border radius for rounded corners
            color: Colors.black, // Color for dropdown text
            fontSize: 13,
            fontWeight: 600,
            fontFamily: Fonts.Poppins,
            padding: "4px 8px", // Padding inside the select dropdown
            "&:focus": {
              borderRadius: "5px", // Keep border radius on focus
              borderColor: Colors.primaryColor, // Border color on focus
            },
          },
        }}
        SelectProps={{
          inputProps: { "aria-label": "rows per page" },
          native: true,
          value: rowsPerPage, // Make sure the value is always set to rowsPerPage
        }}
      />
    </Box>
  );
};

export default PaginationComponent;
